import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  policyCards: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}));
